import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { createSelectors } from '../utils/createSelector'

type UIState = {
  isAudioPlayerSmall: boolean
  isLoginModalOpen: boolean
  commandPalettesNameOpen: string | null
}

type UIActions = {
  setIsAudioPlayerSmall: () => void
  toggleLoginModal: () => void
  openCommandPalettes: (name: string) => void
  closeCommandPalettes: () => void
  resetState: () => void
}


type UIGetters = {
  isCommandPalettesOpen: (name: string) => boolean
}

const defaultState: UIState = {
  isAudioPlayerSmall: false,
  isLoginModalOpen: false,
  commandPalettesNameOpen: null
}

export const useUIStore = createSelectors(
  create<UIState & UIActions & UIGetters>()(
    immer((set, get) => ({
      ...defaultState,
      // GETTERS
      isCommandPalettesOpen: (name: string) => get().commandPalettesNameOpen === name,

      // ACTIONS
      toggleLoginModal: () =>
        set((state) => {
          state.isLoginModalOpen = !state.isLoginModalOpen
        }),
      setIsAudioPlayerSmall: () =>
        set((state) => {
          state.isAudioPlayerSmall = !state.isAudioPlayerSmall
        }),

      openCommandPalettes: (name: string) =>
        set((state) => {
          state.commandPalettesNameOpen = name
        }),

      closeCommandPalettes: () =>
        set((state) => {
          state.commandPalettesNameOpen = null
        }),

      resetState: () => set(defaultState),
    })),
  ),
)
